import React from 'react';
import CustomButton from '../customButton';
//import { Link } from 'react-router-dom';
import dokuCardsCss from './dokuCards.module.css';
import { axiosAuthFetchDelete } from '../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../constants';

export function DokumentasjonsCard({ product, ordered_id, documentation, serial }) {

    const {name, supplier, image} = product;

    // console.log('Documentation:', documentation);

    // varenummer er fjernet fra const'en over

    const redirectToDocumentation = () => {
        window.location.href=`/VP/admin/dokumentasjon/${ordered_id}`;
    }

    const deleteProduct = async () => {
        try {
            await axiosAuthFetchDelete(`${API_BASE_URL}/ordered-products/${ordered_id}`)
            alert('Produktet ble slettet')
            window.location.reload();
        } catch(error) {
            console.error(error);
            alert('Oida, noe gikk galt')
        }
    };

    return(
        
        // <div className={columnClass}>
            <div className={dokuCardsCss.card}>
                <div>
                    <div className={dokuCardsCss.imageContainer} 
                           style={{
                               backgroundImage: `url(${image?.data?.attributes?.url})`,
                               backgroundRepeat: 'no-repeat',
                               backgroundSize: 'contain',
                               width: '10em',
                               height: '10em',
                           }}
                       />
                       {supplier?.data?.attributes?.name && (
                               <div className={dokuCardsCss.supplier}>
                                   <p>fra {supplier.data.attributes.name}</p>
                               </div>
                           )}
                       <div className={dokuCardsCss.title}>
                           {name}
                       </div>
                       <div className={dokuCardsCss.title}>
                            {product.varenummer}
                       </div>
                       
                       <div className="mt-4 d-flex flex-column justify-content-center align-items-center">
                                <div>Serienummer:</div> 
                                <div>{serial}</div>
                            </div>
                       <div className="d-flex flex-column justify-content-center align-items-center text-center mt-auto">
                          
                               <CustomButton 
                                   label="Mer informasjon"
                                   className={`${dokuCardsCss.cardButton} ${dokuCardsCss.infoButton} knapp`}
                                   onClick={redirectToDocumentation}
                               />
                               {/* <CustomButton 
                                   label="Rediger informasjon"
                                   className={`${dokuCardsCss.cardButton} ${dokuCardsCss.editButton} knapp`}
                               /> */}
                               <CustomButton 
                                   label="Slett produkt"
                                   className={`${dokuCardsCss.cardButton} ${dokuCardsCss.deleteButton} knapp`}
                                   onClick={deleteProduct}
                               />
                       </div>
                </div>
                 
            </div>
        // </div>
    )
}

export default DokumentasjonsCard;